import React from 'react';
import { Badge } from '@/components/ui/badge';

type Props = {
  label: string;
};

export const SkillOptionLabel: React.FC<React.PropsWithChildren<Props>> = ({
  label,
}) => (
  <Badge variant="light" className="fs-base">
    {label}
  </Badge>
);
